import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  makeStyles,
  MenuItem,
  Grid,
  TextareaAutosize,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useAlert } from "react-alert";
import { EditSetupLots, getFindById } from "../../../adminModel/lots";
import Color from "../../../utils/colors";
import { useParams } from "react-router-dom";
import Image from "./Image";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTypography-h5": {
      color: Color.green,
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  avatar: {
    height: 100,
    width: 100,
  },
}));

const Create = ({ className, ...rest }) => {
  const classes = useStyles();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  var { auctionId, setId, id } = useParams();
  const [getDetails, setDetails] = useState([]);

  const FetchAuction = useCallback(async () => {

    setLoading(true);

    async function getAuction() {
      const response = await getFindById(auctionId, setId, id);
      console.log("results response ",response)
      setLoading(false);
      setDetails(response.image);
      let results = {};
      response.data.map((val)=>{
        return (results = val)
    })


      setValues({
        lot_number: results.lot_number,
        artist: results.artist,
        title: results.title,
        starting_price: results.starting_price,
        signed_dated: results.signed_dated,
        medium: results.medium,
        size: results.size,
        property: results.property,
        coa: results.coa,
        provenance: results.provenance,
        exhibited: results.exhibited,
        literature: results.literature,
        write_up: results.write_up,
        lot_group: results.lot_group,
        lot_details_html: results.lot_details_html,
        alias: results.alias,
        hp: results.hp,
        bp: results.bp,
        // hammerPrice: results.ham,
      });
    }
    getAuction().catch(console.error);
  }, [auctionId,id]);

  useEffect(() => {
    FetchAuction();
  }, [FetchAuction]);

  const [values, setValues] = useState({
    lot_number: "",
    artist: "",
    title: "",
    starting_price: "",
    signed_dated: "",
    medium: "",
    size: "",
    property: "",
    coa: "",
    provenance: "",
    exhibited: "",
    literature: "",
    write_up: "",
    lot_group: "",
    lot_details_html: "",
    alias: "",
    hp: "",
    bp: "",
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const lotsData = {
      auction_id: auctionId,
      set_id: setId,
      lot_number: id,
      artist: values.artist,
      title: values.title,
      starting_price: values.starting_price,
      signed_dated: values.signed_dated,
      medium: values.medium,
      size: values.size,
      property: values.property,
      coa: values.coa,
      provenance: values.provenance,
      exhibited: values.exhibited,
      literature: values.literature,
      write_up: values.write_up,
      lot_group: values.lot_group,
      lot_details_html: values.lot_details_html,
      alias: values.alias,
      hp: parseInt(values.hp),
      bp: values.bp,
    };

    try {
      const result = await EditSetupLots(lotsData);
      setLoading(false);
      alert.success(result);
      // setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  // var reader = new FileReader();
  // const url = reader.readAsDataURL(auction_banner);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <form
            onSubmit={handleFormSubmit}
            autoComplete="off"
            className={clsx(classes.root, className)}
            {...rest}
          >
            <Card>
              <CardHeader title="Data Entry" />
              <Divider />
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item md={6} >
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Lot Number"
                      name="lot_number"
                      value={values.lot_number}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      
                      variant="outlined"
                      onChange={handleChange}
                    />

                    <TextField
                      fullWidth
                      label="Artist"
                      margin="normal"
                      name="artist"
                      value={values.artist}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      type="text"
                      
                      variant="outlined"
                      onChange={handleChange}
                    />
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Title"
                      name="title"
                      value={values.title}
                      type="text"
                      
                      variant="outlined"
                      onChange={handleChange}
                    />

                    <TextField 
                      fullWidth
                      margin="normal"
                      label="Signed Dated"
                      name="signed_dated"
                      type="text"
                      value={values.signed_dated}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                  
                    <TextField
                      margin="normal"     
                      fullWidth
                      label="Medium"
                      name="medium"
                      type="text"
                      value={values.medium}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

              <TextField
                      fullWidth
                      margin="normal"
                      label="Size"
                      name="size"
                      value={values.size}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      
                      margin="normal"
                      fullWidth
                      label="Lot Group"
                      name="lot_group"
                      value={values.lot_group}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  <TextField
                      margin="normal"
                      fullWidth
                      label="Starting Price"
                      name="starting_price"
                      value={values.starting_price}
                      type="number"
                      
                      variant="outlined"
                      onChange={handleChange}
                    />

                  <TextField
                      margin="normal"
                      fullWidth
                      label="Hammer Price"
                      name="hp"
                      multiline
                      // minRows={4}
                      value={values.hp}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                  <TextField
                      margin="normal"
                      fullWidth
                      label="Buyer's Premium"
                      name="bp"
                      multiline
                      // minRows={4}
                      value={values.bp}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />


                    <Image ItemData={getDetails}  />
                  </Grid>

                  <Grid item md={6} xs={12}>

                    <TextField
                      margin="normal"
                      fullWidth
                      
                      label="Property"
                      name="property"
                      value={values.property}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Coa"
                      name="coa"
                      value={values.coa}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      
                      fullWidth
                      multiline
                      minRows={4}
                      label="Exhibited"
                      name="exhibited"
                      value={values.exhibited}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      
                      fullWidth
                      label="Alias"
                      multiline
                      minRows={4}
                      name="alias"
                      value={values.alias}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      
                      fullWidth
                      multiline
                      minRows={4}
                      label="Provenance"
                      name="provenance"
                      value={values.provenance}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      
                      fullWidth
                      multiline
                      minRows={4}
                      label="literature"
                      name="literature"
                      value={values.literature}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="lot_details_html"
                      name="lot_details_html"
                      value={values.lot_details_html}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />


        
{/* <TextareaAutosize
  // maxRows={4}
  value={values.write_up}
  aria-label="maximum height"
  placeholder="Write up"
  name="write_up"
  onChange={handleChange}
  fullWidth
  InputLabelProps={{
    shrink: true,
  }}
  style={{ width: 520 }}
/>
 */}


{/* <TextareaAutosize
  // maxRows={4}
  value={values.write_up}
  aria-label="maximum height"
  placeholder="Write up"
  name="write_up"
  onChange={handleChange}
  fullWidth
  InputLabelProps={{
    shrink: true,
  }}
  style={{ width: '100' }}
/> */}

                    <TextField
                      margin="normal"
                      
                      fullWidth
                      label="Write up"
                      name="write_up"
                      multiline
                      minRows={4}
                      value={values.write_up}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />


                      
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                  color="primary"
                  // disabled={disable}
                  // style={Api.Button_save}
                  variant="contained"
                  type="submit"
                >
                  Save Details
                </Button>
              </Box>
            </Card>
          </form>
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

Create.propTypes = {
  className: PropTypes.string,
};

export default Create;
